import { PlatformSiteAri } from '@atlassian/ari';

import { query } from '@confluence/query-preloader-tools';
import { expVal } from '@confluence/feature-experiments';

import { PAGE_SIZE } from './recentQueryConfig';
import {
	RecentContentMenuQuery,
	RecentContentMenuQueryV3,
} from './queries/RecentContentMenuQuery.graphql';

export function preloadRecentContentMenu(cloudId) {
	return query({
		query: expVal('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false)
			? RecentContentMenuQueryV3
			: RecentContentMenuQuery,
		variables: {
			cloudId: expVal('confluence_activity_v3_collaborated_on_experiment', 'isEnabled', false)
				? PlatformSiteAri.create({ siteId: cloudId }).toString()
				: cloudId,
			after: '',
			first: PAGE_SIZE,
			eventTypes: [],
		},
		fetchPolicy: 'network-only',
	});
}
